import { Backdrop, CircularProgress } from '@mui/material'

function ScreenLoading({ loadings }: { loadings: boolean[] }) {
  return (
    <>
      {loadings.some(loading => loading) && (
        <Backdrop sx={{ root: { zIndex: 9999 } }} open={true} className="root">
          <CircularProgress role="status" color="inherit" />
        </Backdrop>
      )}
    </>
  )
}

export default ScreenLoading
